module.exports = __webpack_public_path__ + "static/2-e8d3373e5141b0af71faa9f845e1f0ee.png";